import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { login, getMe } from '../services/api';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

export default function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const { loginUser }           = useAuth();
  const navigate                = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res   = await login(email, password);
      localStorage.setItem('token', res.data.access_token);
      const meRes = await getMe();
      loginUser(res.data.access_token, meRes.data);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.detail || 'Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-split">

        {/* Left — branding */}
        <div className="auth-left">
          <Link to="/" className="auth-brand">
            <span className="auth-brand-tag mono">Daily AI Puzzles</span>
            <span className="auth-brand-name">Puzzle<span>Forge</span></span>
          </Link>
          <p className="auth-tagline">Your daily brain workout.<br/>5 AI puzzles, every day.</p>
          <div className="auth-features">
            <div className="auth-feature">
              <span className="auth-feature-icon">🔥</span>
              <div>
                <strong>Daily Streaks</strong>
                <span>Track your consistency</span>
              </div>
            </div>
            <div className="auth-feature">
              <span className="auth-feature-icon">🔤</span>
              <div>
                <strong>WordForge</strong>
                <span>Free daily word puzzle</span>
              </div>
            </div>
            <div className="auth-feature auth-feature-locked">
              <span className="auth-feature-icon">🌍</span>
              <div>
                <strong>GeoForge + 3 more</strong>
                <span>Unlock all puzzles with Premium</span>
              </div>
              <span className="auth-lock mono">Premium</span>
            </div>
          </div>
        </div>

        {/* Right — form */}
        <div className="auth-right">
          <div className="auth-card">
            <h2 className="auth-title mono">Welcome back</h2>
            <p className="auth-sub mono">Login to track your streak</p>

            {error && <div className="auth-error mono">{error}</div>}

            <form onSubmit={handleSubmit} className="auth-form">
              <div className="auth-field">
                <label className="auth-label mono">Email</label>
                <input
                  className="auth-input mono"
                  type="email" value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                />
              </div>
              <div className="auth-field">
                <label className="auth-label mono">Password</label>
                <input
                  className="auth-input mono"
                  type="password" value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                />
              </div>
              <button type="submit" className="auth-submit mono" disabled={loading}>
                {loading ? 'Logging in...' : 'Login →'}
              </button>
            </form>

            <p className="auth-switch mono" style={{marginTop: '20px'}}>
              No account? <Link to="/register">Sign up free</Link>
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}
